import { Spinner } from '@/components/ui/spinner';

const PageLoadingFallback: React.FC<{
  message?: string;
  description?: string;
}> = ({ message = 'Loading', description }) => (
  <div className="flex items-center justify-center min-h-[400px] animate-fade-in">
    <div className="text-center">
      <div className="size-14 rounded-2xl bg-primary/[0.06] flex items-center justify-center mx-auto mb-5">
        <Spinner className="size-7 text-primary" />
      </div>
      <h3 className="text-base font-semibold text-foreground mb-1.5 tracking-tight">{message}</h3>
      {description && <p className="text-sm text-muted-foreground">{description}</p>}
    </div>
  </div>
);

export default PageLoadingFallback;
